import { ENV } from "./env";

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  if (ENV.PIXEL_ID) {
    // Meta Pixel
    /* eslint-disable */
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq?.("init", ENV.PIXEL_ID);
    window.fbq?.("track", "PageView");
  }

  if (ENV.GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ENV.GA_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer!.push(arguments); } as never;
    window.gtag("js", new Date());
    window.gtag("config", ENV.GA_ID);
  }
}

export function trackPageView(path: string) {
  if (typeof window === "undefined") return;
  window.fbq?.("track", "PageView");
  if (ENV.GA_ID) window.gtag?.("event", "page_view", { page_path: path });
}

export function trackEvent(name: string, params?: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  window.gtag?.("event", name, params || {});
}

export function trackLead(params?: Record<string, unknown>) {
  window.fbq?.("track", "Lead", params);
  trackEvent("roadmap_completed", params);
}

export function trackSchedule(params?: Record<string, unknown>) {
  window.fbq?.("track", "Schedule", params);
  trackEvent("confirmation_view", params);
}
